import { hasInvoiceLink, isPayEnabled, statusLabel } from "../../../Pages/Main/Retailer/Invoice/invoiceUtils";

export function TestSuite() {
  // To run tests in browser console:
  // window.__RUN_INVOICE_UI_TESTS__ = true; location.reload();
  if (typeof window === "undefined") return null;
  if (!window.__RUN_INVOICE_UI_TESTS__) return null;

  const tests = [];
  const test = (name, fn) => tests.push({ name, fn });
  const expect = (cond, msg) => {
    if (!cond) throw new Error(msg || "Assertion failed");
  };

  test("statusLabel paid", () => {
    expect(statusLabel({ status: "paid" }) === "PAID", "paid should be PAID");
  });

  test("statusLabel overdue via current_sub_status", () => {
    expect(
      statusLabel({ status: "sent", current_sub_status: "overdue" }) === "OVERDUE",
      "should be OVERDUE"
    );
  });

  test("hasInvoiceLink true when invoice_url exists", () => {
    expect(hasInvoiceLink({ invoice_url: "https://x" }) === true, "should have link");
  });

  test("hasInvoiceLink false when invoice_url missing", () => {
    expect(hasInvoiceLink({}) === false, "should not have link");
  });

  // ✅ Added tests for Pay Now enable rule
  test("isPayEnabled true only when balance > 0 and invoice_url exists", () => {
    expect(isPayEnabled({ invoice_url: "https://x", balance: 1 }) === true, "should be enabled");
  });

  test("isPayEnabled false when balance is 0", () => {
    expect(isPayEnabled({ invoice_url: "https://x", balance: 0 }) === false, "should be disabled");
  });

  test("isPayEnabled false when invoice_url missing", () => {
    expect(isPayEnabled({ balance: 10 }) === false, "should be disabled without link");
  });

  // Run
  try {
    for (const t of tests) t.fn();
    // eslint-disable-next-line no-console
    console.log("Invoice UI tests: OK (", tests.length, ")");
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error("Invoice UI tests: FAILED", e);
  }

  return null;
}